// =====================================
// NO EDITAR ESTE ARCHIVO DIRECTO
// COMPILADO 2025-03-13 17:27:51
// =====================================

enum POSTINGS{
	_ID = 1,		// Trabajos
	VIEW_POSTINGS = 1000,		// Ver empleos
	CREATE_POSTING = 1001,		// Crear empleos
	EDIT_POSTING = 1002,		// Editar empleos
	EDIT_POSTING_DATE = 1003,		// Editar fecha de empleos
	EDIT_POSTING_LIMIT = 1004,		// Editar cupo de empleos
	EDIT_POSTING_LOCATION = 1005,		// Editar ubicación de empleos
	EDIT_POSTING_IMAGE = 1006,		// Editar imagen de empleos
	VIEW_JOB = 1100,		// Ver puestos
	CREATE_JOB = 1101,		// Crear puestos
	EDIT_JOB = 1102,		// Editar puetos
	DELETE_JOB = 1199,		// Eliminar puestos
	CANCEL_POSTING = 1900,		// Cancelar empleos
}
enum USERS{
	_ID = 2,		// Trabajadores
	APPROVE_USERS = 2000,		// Aprobar trabajadores
	REMOVE_USERS = 2001,		// Remover trabajadores
	EDIT_USER_PAY = 2002,		// Editar paga de trabajador
	BAN_USER = 2900,		// Prohibir trabajador
}
enum ADMIN{
	_ID = 3,		// Administración
	EDIT_BUSINESS_INFO = 3000,		// Editar información de negocio
	EDIT_BUSINESS_IMAGE = 3001,		// Cambiar imagen de negocio
	ADD_USER = 3100,		// Agregar usuario
	EDIT_USER_ACCESS = 3101,		// Editar permisos de usuario
	REMOVE_USER_ACCESS = 3102,		// Eliminar usuarios
}
enum ACCOUNTING{
	_ID = 10,		// Finanzas
	VIEW_PAYOUTS = 10000,		// Ver liquidaciones
	CREATE_PAYOUTS = 10001,		// Crear liquidaciones
	CREATE_BUSINESS_CREDIT = 10002,		// Bonificar dinero
	EDIT_USER_PAYMENT = 10003,		// Editar pago de trabajador
	PAID_USER_PAYMENT = 10004,		// Pagar a trabajador
	CANCEL_USER_PAYMENT = 10005,		// Cancelar pago de trabajador
	EDIT_TAX_INFO = 10100,		// Editar datos fiscales
}
const ACCESS_ARRAY = [
	{
		id: 1,
		varname: 'POSTINGS',
		name: 'Trabajos',
		access: [
			{ id: 1000, name: 'Ver empleos' },
			{ id: 1001, name: 'Crear empleos' },
			{ id: 1002, name: 'Editar empleos' },
			{ id: 1003, name: 'Editar fecha de empleos' },
			{ id: 1004, name: 'Editar cupo de empleos' },
			{ id: 1005, name: 'Editar ubicación de empleos' },
			{ id: 1006, name: 'Editar imagen de empleos' },
			{ id: 1100, name: 'Ver puestos' },
			{ id: 1101, name: 'Crear puestos' },
			{ id: 1102, name: 'Editar puetos' },
			{ id: 1199, name: 'Eliminar puestos' },
			{ id: 1900, name: 'Cancelar empleos' },
		],
	},
	{
		id: 2,
		varname: 'USERS',
		name: 'Trabajadores',
		access: [
			{ id: 2000, name: 'Aprobar trabajadores' },
			{ id: 2001, name: 'Remover trabajadores' },
			{ id: 2002, name: 'Editar paga de trabajador' },
			{ id: 2900, name: 'Prohibir trabajador' },
		],
	},
	{
		id: 3,
		varname: 'ADMIN',
		name: 'Administración',
		access: [
			{ id: 3000, name: 'Editar información de negocio' },
			{ id: 3001, name: 'Cambiar imagen de negocio' },
			{ id: 3100, name: 'Agregar usuario' },
			{ id: 3101, name: 'Editar permisos de usuario' },
			{ id: 3102, name: 'Eliminar usuarios' },
		],
	},
	{
		id: 10,
		varname: 'ACCOUNTING',
		name: 'Finanzas',
		access: [
			{ id: 10000, name: 'Ver liquidaciones' },
			{ id: 10001, name: 'Crear liquidaciones' },
			{ id: 10002, name: 'Bonificar dinero' },
			{ id: 10003, name: 'Editar pago de trabajador' },
			{ id: 10004, name: 'Pagar a trabajador' },
			{ id: 10005, name: 'Cancelar pago de trabajador' },
			{ id: 10100, name: 'Editar datos fiscales' },
		],
	},
]

export default {
	ACCESS_ARRAY,
	POSTINGS,
	USERS,
	ADMIN,
	ACCOUNTING,
}